import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/auth/silent')({
	// Platzhalteransicht fuer den Silent-Auth-Callback.
	component: () => <p>…</p>,
})
